module.exports = __webpack_public_path__ + "static/media/background-isa.569fabb8.svg";